import { bootstrapTaskpaneApp } from "@acto/taskpane/core/bootstrap";

void bootstrapTaskpaneApp();
